import { useState,useEffect,useRef  } from "react";
import { fetchUsers, fetchDivision, fetchSubject, postMarketIntelliagence } from "Service/ApiService";
import { showAlert } from "utils/ErrorMessage";
import { showSuccessAlert } from "utils/SuccessMessage";


const MarketIntelligenceController = (initialState) => {
  const [loading, setloading] = useState(false);
  const [subjectlist, setSubject] = useState([]);
  const [divisionlist, setDivision] = useState([]);
  const [userlist, setUsers] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [formData, setFormData] = useState(initialState);
  const [isPhysicalItemCollected, setPhysicalItemCollected] = useState(false);
  const upload_file = useRef();

const initialFormData = {
  subject: "",
  division: "",
  user: "",
  uploaded_file: "",
  price_cost_meter: "",
  remark: ""
};


  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    setloading(true);
    try {
      await Promise.all([getSubject(), getDivision(), getAssignUser()]);
    } catch (error) {
      console.error('Error fetching reports:', error);
    } finally {
      setloading(false);
    }
  };

  const getSubject = async () => {
    try {
      const response = await fetchSubject();
      if (response && response.success === true) {
        const options = response.data.map((row) => ({
          value: row.subject_id,
          label: row.subject_name
        }));
        setSubject(options);
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      console.error('Error fetching Outstanding Report:', error);
    }
  }

  const getDivision = async () => {
    try {
      const response = await fetchDivision();
      if (response && response.success === true) {
        setDivision(response.data);
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      console.error('Error fetching Outstanding Report:', error);
    }
  }

  const getAssignUser = async () => {
    try {
      const response = await fetchUsers(searchText);
      if (response && response.success === true) {
        const options = response.data.map((row) => ({
          value: row.userCode,
          label: row.displayName
        }));
        setUsers(options);
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      console.error('Error fetching Outstanding Report:', error);
    }
  }


  const handleSelectChange = (selectedOption,e) => {
    setFormData({
      ...formData,
      [e.name]: selectedOption
    });
  };

  const handleInputChange = (inputValue) => {
    setSearchText(inputValue);
  };

  const handleRInputChange = (e) => {
  const { name, value } = e.target;
  if (name === "price_cost_meter") {
    const numericValue = value.replace(/[^0-9.]/g, "");
    const validPattern = /^\d*\.?\d{0,2}$/;
    if (!validPattern.test(numericValue)) return;
    setFormData({
      ...formData,
      [name]: numericValue,
    });
    return;
  }
  setFormData({
    ...formData,
    [name]: value,
  });
};
  
const handleOnChange = () => {
  if (isPhysicalItemCollected) {
    setPhysicalItemCollected(false);
  }else{
    setPhysicalItemCollected(true);
  }
}

const handleChange = (e) => {
  const { name, files } = e.target;
  const maxFiles = 3;
  const maxSize = 200 * 1024 * 1024;
  const allowedExtensions = [".jpg", ".jpeg", ".png", ".pdf", ".xlsx", ".xls", ".csv", ".doc", ".docx"];

  let selectedFiles = Array.from(files);

  if (selectedFiles.length > maxFiles) {
    showAlert(`You can upload a maximum of ${maxFiles} files.`);
    if (upload_file.current) {
      upload_file.current.value = "";
    }
    return;
  }

  const oversizedFiles = selectedFiles.filter((file) => file.size > maxSize);
  if (oversizedFiles.length > 0) {
    if (upload_file.current) {
      upload_file.current.value = "";
    }
    showAlert("Each file must be smaller than 200 MB.");
    return;
  }

  const invalidTypeFiles = selectedFiles.filter((file) => {
    const lowerName = file.name.toLowerCase();
    return !allowedExtensions.some((ext) => lowerName.endsWith(ext));
  });
  if (invalidTypeFiles.length > 0) {
    if (upload_file.current) {
      upload_file.current.value = "";
    }
    showAlert("Invalid file type. Allowed: JPG, PNG, PDF, XLS/XLSX, CSV, DOC/DOCX.");
    return;
  }

  setFormData({
    ...formData,
    [name]: selectedFiles,
  });
};

  useEffect(() => {
      getAssignUser();
    }, [searchText]);


const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    
    // 3️⃣ Other optional validation if needed
    if (!formData.subject) {
      showAlert("Please select a subject.");
      return;
    }

    if (!formData.division) {
      showAlert("Please select a division.");
      return;
    }

    const selectedFiles = Array.isArray(formData.uploaded_file) ? formData.uploaded_file : [];
    if (!selectedFiles.length) {
      showAlert("Please upload at least one file.");
      return;
    }

    const priceCostMeter = String(formData.price_cost_meter ?? "").trim();
    if (!priceCostMeter) {
      showAlert("Please enter Price/Cost Meter.");
      return;
    }

    const priceValue = Number(priceCostMeter);
    if (!Number.isFinite(priceValue) || priceValue <= 0) {
      showAlert("Price/Cost Meter must be a valid positive number.");
      return;
    }

    // 1️⃣ Physical Item Collected validation
    if (isPhysicalItemCollected && !formData.user) {
      showAlert("Please select a user for Physical Item Collected.");
      return;
    }


    // 4️⃣ If all validation pass → submit data
    setloading(true);

    const payload = {
      ...formData,
      division: formData.division?.value || formData.division,
      user: isPhysicalItemCollected ? formData.user?.value || formData.user : "",
      isPhysicalItemCollected: isPhysicalItemCollected ? "1" : "0",
    };
  //  console.log(payload);
    

    try {
      const response = await postMarketIntelliagence(payload);
      if (response && response.success === true) {
        setFormData(initialFormData);
        if (upload_file.current) {
            upload_file.current.value = "";
          }
          setPhysicalItemCollected(false)
        showSuccessAlert(response.msg);
      } else {
        showAlert(response.msg);
      }
    } catch (error) {
      console.error('Error fetching Outstanding Report:', error);
    }

    console.log("Form submitted successfully:", payload);

  } catch (error) {
    console.error("Submit Error:", error);
    showAlert("Something went wrong during submission.");
  } finally {
    setloading(false);
  }
};


  return {
    loading,
    subjectlist,
    divisionlist,
    userlist,
    formData,
    upload_file,
    handleSelectChange,
    handleInputChange,
    handleRInputChange,
    handleChange,
    isPhysicalItemCollected,
    handleOnChange,
    handleSubmit
  };

}
export default MarketIntelligenceController;


